module.exports = __webpack_public_path__ + "images/Thunder.aba655451222ccccb3fab404956c300c.svg";